import { render, staticRenderFns } from "./FileUploadView.vue?vue&type=template&id=08bb7534"
import script from "./FileUploadView.vue?vue&type=script&lang=js"
export * from "./FileUploadView.vue?vue&type=script&lang=js"
import style0 from "./FileUploadView.vue?vue&type=style&index=0&id=08bb7534&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports